import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24",
  style: {"display":"grid","justify-content":"center"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", { style: {"font-size":"30px","font-weight":"800"} }, "Aguarde!", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Este recurso já esta chegando no NeoX.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "ss-imagem-pagina-alerta",
  style: {"width":"350px"},
  width: "350px",
  src: "/static/img/ilustracoes/hello-world.svg"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", null, [
          _createElementVNode("a", {
            class: "ant-btn ant-btn-lg ant-btn-primary ss-botao-pagina-alerta",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.voltar && _ctx.voltar(...args)))
          }, "Voltar")
        ])
      ])
    ])
  ]))
}